/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Detail_Page_Purchase_NoteInputs */

const en_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# Subscription Reminders

### Trial Period Details
At the end of the trial period, your selected plan will be automatically renewed.
If you cancel during the trial, you can still access all Plus features until the trial expires. Additionally, planting real trees with coins is not supported during the trial period.

### Renewal & Billing
Your subscription will renew automatically for the same period. However, if you cancel at least 24 hours before your next renewal date, you won’t be charged for the next billing cycle.
You can cancel anytime via the app store. After cancellation, you’ll still have access to Plus features until the subscription expires.`)
};

const ar_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# تذكيرات الاشتراك 

### تفاصيل الفترة التجريبية 
في نهاية الفترة التجريبية، سيتم تجديد الخطة المحددة تلقائيًا. 
إذا قمت بالإلغاء أثناء الفترة التجريبية، فلا يزال بإمكانك الوصول إلى جميع ميزات بلس حتى انتهاء الفترة التجريبية. بالإضافة إلى ذلك، لا يتم دعم زراعة الأشجار الحقيقية بالعملات المعدنية خلال الفترة التجريبية.

### التجديد والفواتير 
سيتم تجديد اشتراكك تلقائيًا لنفس الفترة. ومع ذلك، إذا قمت بالإلغاء قبل 24 ساعة على الأقل من تاريخ التجديد التالي، فلن يتم تحصيل رسوم دورة الفواتير التالية منك. 
يمكنك الإلغاء في أي وقت عبر متجر التطبيقات. بعد الإلغاء، لا يزال بإمكانك الوصول إلى ميزات بلس حتى انتهاء صلاحية الاشتراك.`)
};

const de_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# Abonnement-Erinnerungen

### Details zur Probezeit
Am Ende des Testzeitraums wird das von Ihnen gewählte Abonnement automatisch verlängert.
Wenn Sie während des Testzeitraums kündigen, können Sie bis zum Ablauf des Testzeitraums weiterhin auf alle Plus-Funktionen zugreifen. Außerdem wird das Pflanzen echter Bäume mit Münzen während des Probezeitraums nicht unterstützt.

### Verlängerung & Abrechnung
Ihr Abonnement verlängert sich automatisch um den gleichen Zeitraum. Wenn Sie jedoch mindestens 24 Stunden vor dem nächsten Verlängerungsdatum kündigen, werden Ihnen die Kosten für den nächsten Abrechnungszyklus nicht in Rechnung gestellt.
Sie können jederzeit über den App-Store kündigen. Nach der Kündigung haben Sie weiterhin Zugang zu den Plus-Funktionen, bis das Abonnement abläuft.`)
};

const es_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# Recordatorios de suscripción

### Detalles del periodo de prueba
Al final del periodo de prueba, el plan seleccionado se renovará automáticamente.
Si cancelas durante el periodo de prueba, podrás seguir accediendo a todas las funciones Plus hasta que caduque este periodo. Además, la función de plantar árboles reales con monedas no está disponible durante el periodo de prueba.

### Renovación y facturación
Tu suscripción se renovará automáticamente por el mismo periodo. Sin embargo, si la cancelas al menos 24 horas antes de la siguiente fecha de renovación, no se te cobrará el siguiente ciclo de facturación.
Puedes cancelar en cualquier momento a través de la tienda de aplicaciones. Tras la cancelación, seguirás teniendo acceso a las funciones Plus hasta que caduque la suscripción.`)
};

const fr_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# Rappels concernant votre abonnement

### À propos de votre période d'essai
À la fin de votre période d'essai, le forfait que vous avez choisi sera automatiquement renouvelé.
Si vous décidez d'annuler pendant l'essai, vous pourrez continuer à profiter de toutes les fonctionnalités Plus jusqu'à son expiration. De plus, la plantation de vrais arbres avec des pièces n'est pas disponible pendant la période d'essai.

### Renouvellement et facturation
Votre abonnement se renouvelle automatiquement pour la même durée. Cependant, si vous souhaitez l'annuler, faites-le au moins 24 heures avant la date de renouvellement pour éviter toute facturation pour le cycle suivant.
Vous pouvez annuler à tout moment via la boutique d’applications. Après l'annulation, vous conserverez l'accès à tous les avantages Plus jusqu'à l'expiration de votre abonnement.`)
};

const it_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# Promemoria per l'Abbonamento

### Dettagli sul periodo di prova
Al termine del periodo di prova, il piano selezionato verrà rinnovato automaticamente.
Se annulli l'abbonamento durante il periodo di prova, puoi comunque accedere a tutte le funzionalità Plus fino alla scadenza del periodo di prova. Inoltre, piantare alberi veri con le monete non è supportato durante il periodo di prova.

### Rinnovo e fatturazione
L'abbonamento si rinnoverà automaticamente per lo stesso periodo. Tuttavia, se annulli almeno 24 ore prima della data di rinnovo successiva, non ti verrà addebitato alcun costo per il ciclo di fatturazione successivo.
Puoi annullare in qualsiasi momento tramite lo store di applicazioni. Dopo l'annullamento, avrai ancora accesso alle funzionalità Plus fino alla scadenza dell'abbonamento.`)
};

const ja_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# サブスクリプションに関する注意点

### トライアル期間の詳細
トライアル期間終了時に、選択したプランが自動的に更新されます。
トライアル期間中にキャンセルした場合でも、トライアル期間が終了するまですべてのPlus機能をご利用いただけます。また、トライアル期間中はコインを使った本物の木の植樹機能はご利用いただけません。

### 更新と請求
サブスクリプションは同じ期間自動的に更新されます。ただし、次の更新日の24時間前までにキャンセルした場合、次の請求サイクルに対して請求されることはありません。
アプリストアからいつでもキャンセルできます。キャンセル後も、サブスクリプションの有効期限が切れるまでPlus機能をご利用いただけます。`)
};

const ko_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# 구독 알림

### 체험판 기간 세부 정보
체험 기간이 끝나면 선택한 플랜이 자동으로 갱신돼요.
체험 기간 도중에 취소해도 체험판이 끝날 때까지 모든 Plus 기능을 계속 이용할 수 있어요. 또한, 체험 기간 중에는 코인으로 실제 나무를 심는 기능이 지원되지 않아요.

### 갱신 및 결제
구독은 동일 기간으로 자동 갱신돼요. 그러나 다음 갱신 날짜 최소 24시간 전에 취소하면 다음 결제 기간에 대한 요금이 청구되지 않아요.
언제든지 앱 스토어에서 구독을 취소할 수 있어요. 취소 후에도 구독이 만료될 때까지 Plus 기능을 계속 이용할 수 있어요.`)
};

const pt_br_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# Lembretes sobre a assinatura

### Detalhes do período de teste
No final do período de teste, o plano selecionado será renovado automaticamente.
Se efetuar o cancelamento durante o período de teste, você ainda terá acesso a todas as funcionalidades Plus até a data de expiração do teste grátis. Além disso, o plantio de árvores reais com moedas não é suportado durante o período de teste.

### Renovação e cobrança
Sua assinatura será renovada automaticamente pelo mesmo período. No entanto, se você efetuar o cancelamento com pelo menos 24 horas de antecedência da próxima data de renovação, a fatura do próximo ciclo não será cobrada.
Você pode efetuar o cancelamento a qualquer momento pela loja de aplicativos. Após o cancelamento, você ainda terá acesso aos recursos Plus até a data de expiração da assinatura.`)
};

const ru_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# Напоминания о подписке

### Подробности пробного периода
По окончании пробного периода выбранный вами тарифный план будет автоматически продлен.
Если вы отмените подписку во время пробного периода, вы всё ещё сможете пользоваться всеми функциями Plus до истечения срока действия пробного периода. Кроме того, посадка настоящих деревьев за монеты не поддерживается в течение пробного периода.

### Продление и выставление счёта
Ваша подписка будет продлена автоматически на тот же период. Однако если вы отмените подписку не позднее чем за 24 часа до даты следующего продления, плата за следующий расчетный цикл с вас снята не будет.
Вы можете отменить подписку в любое время через магазин приложений. После отмены подписки у вас всё ещё будет доступ к функциям Plus до истечения срока действия подписки.`)
};

const th_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# การแจ้งเตือนการสมัครสมาชิก

### รายละเอียดช่วงทดลองใช้งาน
เมื่อช่วงทดลองใช้งานสิ้นสุดลง แผนที่คุณเลือกไว้จะถูกต่ออายุโดยอัตโนมัติ
หากคุณทำการยกเลิกระหว่างช่วงทดลองใช้งาน คุณยังสามารถเข้าถึงคุณสมบัติ Plus ทั้งหมดได้จนกว่าช่วงทดลองใช้งานจะหมดอายุ นอกจากนี้ ฟีเจอร์การปลูกต้นไม้จริงด้วยเหรียญจะไม่รองรับในช่วงทดลองใช้งาน

### การต่ออายุและการเรียกเก็บเงิน
การสมัครสมาชิกของคุณจะต่ออายุโดยอัตโนมัติในช่วงเวลาเดียวกัน อย่างไรก็ตาม หากคุณทำการยกเลิกก่อนวันต่ออายุครั้งถัดไปอย่างน้อย 24 ชั่วโมง คุณจะไม่ถูกเรียกเก็บเงินสำหรับรอบการเรียกเก็บเงินครั้งถัดไป
คุณสามารถยกเลิกได้ตลอดเวลาผ่านร้านแอปพลิเคชัน หลังจากที่ยกเลิกแล้ว คุณจะยังคงสามารถเข้าถึงคุณสมบัติ Plus ได้จนกว่าการสมัครสมาชิกจะหมดอายุ`)
};

const tr_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# Abonelik Hatırlatmaları

### Deneme Süresi Detayları
Deneme süresinin sonunda, seçtiğin plan otomatik olarak yenilenecektir.
Deneme süresi içinde iptal edersen, deneme süresi sona erene kadar tüm Plus özelliklerine erişmeye devam edebilirsin. Ayrıca, deneme süresi boyunca jetonlarla gerçek ağaç dikme özelliği desteklenmemektedir.

### Yenileme ve Faturalama
Aboneliğin aynı dönem için otomatik olarak yenilenecektir. Ancak aboneliğini bir sonraki yenileme tarihinden en az 24 saat önce iptal edersen bir sonraki faturalandırma döngüsü için ücretlendirilmezsin.
İstediğin zaman uygulama mağazası üzerinden aboneliğini iptal edebilirsin. İptal işleminden sonra, aboneliğin sona erene kadar Plus özelliklerine erişmeye devam edersin.`)
};

const zh_cn_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# 权益说明

### Plus 试用权益说明
试用期满后将自动续费所选方案。若试用中取消，你仍可在试用到期日前享有 Plus 内容与功能。另外试用期间不支持金币种植真树功能。

### 续费扣款说明
你的 Plus 会员将会以相同期限自动续费，但只要在下次续费日的 24 小时前取消，就不会收取下一期费用。你可以随时在应用商城取消，取消后仍可在 Plus 会员到期日前享有 Plus 内容与功能。`)
};

const zh_tw_subscription_detail_page_purchase_note = /** @type {(inputs: Subscription_Detail_Page_Purchase_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# 訂閱權益說明

### 試用權益說明
試用期滿後將自動續訂所選方案。若試用中取消，你仍可在試用到期日前享有 Plus 內容與功能。另外試用期間不支援金幣種植真樹功能。

### 續訂扣款說明
你的訂閱將會以相同期限自動續約，但只要在下次續約日的 24 小時前取消，就不會收取下一期費用。你可以隨時在應用商店取消，取消後仍可在訂閱到期日前享有 Plus 內容與功能。`)
};

/**
* | output |
* | --- |
* | "# Subscription Reminders ### Trial Period Details At the end of the trial period, your selected plan will be automatically renewed. If you cancel during the ..." |
*
* @param {Subscription_Detail_Page_Purchase_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_detail_page_purchase_note = /** @type {((inputs?: Subscription_Detail_Page_Purchase_NoteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Detail_Page_Purchase_NoteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_detail_page_purchase_note(inputs)
	if (locale === "ar") return ar_subscription_detail_page_purchase_note(inputs)
	if (locale === "de") return de_subscription_detail_page_purchase_note(inputs)
	if (locale === "es") return es_subscription_detail_page_purchase_note(inputs)
	if (locale === "fr") return fr_subscription_detail_page_purchase_note(inputs)
	if (locale === "it") return it_subscription_detail_page_purchase_note(inputs)
	if (locale === "ja") return ja_subscription_detail_page_purchase_note(inputs)
	if (locale === "ko") return ko_subscription_detail_page_purchase_note(inputs)
	if (locale === "pt_br") return pt_br_subscription_detail_page_purchase_note(inputs)
	if (locale === "ru") return ru_subscription_detail_page_purchase_note(inputs)
	if (locale === "th") return th_subscription_detail_page_purchase_note(inputs)
	if (locale === "tr") return tr_subscription_detail_page_purchase_note(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_detail_page_purchase_note(inputs)
	return zh_tw_subscription_detail_page_purchase_note(inputs)
});